import { render } from "./ReviewAccountFees.vue?vue&type=template&id=81d25a70"
import script from "./ReviewAccountFees.vue?vue&type=script&lang=js"
export * from "./ReviewAccountFees.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__